import { ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER_ADMIN } from '../../constants/roles';
import { createHasSessionAccessSelector } from '../session';

export const selectCanAccessRoles = createHasSessionAccessSelector([ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER_ADMIN]);